// ---------------------------------------------------------------------------
// SM-2 spaced-repetition math (pure — no DB access, unit-tested).
// Quality 0..5 comes from the graded score; ease/interval/repetitions follow
// the classic SuperMemo-2 update rule.
// ---------------------------------------------------------------------------

export interface Sm2State {
  ease: number;
  intervalDays: number;
  repetitions: number;
}

export const SM2_INITIAL: Sm2State = { ease: 2.5, intervalDays: 0, repetitions: 0 };

/** Map a 0..100 final score onto SM-2's 0..5 quality scale. */
export function qualityFromScore(finalScore: number): number {
  const q = Math.round(finalScore / 20);
  return Math.max(0, Math.min(5, q));
}

/** One SM-2 update step. quality < 3 resets repetitions (review again tomorrow). */
export function sm2Update(state: Sm2State, quality: number): Sm2State {
  const q = Math.max(0, Math.min(5, quality));
  const ease = Math.max(1.3, state.ease + (0.1 - (5 - q) * (0.08 + (5 - q) * 0.02)));
  if (q < 3) {
    return { ease, intervalDays: 1, repetitions: 0 };
  }
  const repetitions = state.repetitions + 1;
  const intervalDays =
    repetitions === 1 ? 1 : repetitions === 2 ? 6 : Math.round(state.intervalDays * ease);
  return { ease, intervalDays: Math.max(1, intervalDays), repetitions };
}

/** Next due date for an interval, from `from` (defaults to now). */
export function dueDate(intervalDays: number, from: Date = new Date()): Date {
  return new Date(from.getTime() + intervalDays * 24 * 60 * 60 * 1000);
}
